import Flex from '@deprecated-ui/common/Flex';
import { Description, NotationTag } from './styled';

interface NotationListItemProps {
  code: string;
  desc: string;
  isUma?: boolean;
}

function NotationListItem({
  code,
  desc,
  isUma = false,
}: NotationListItemProps) {
  return (
    // @ts-expect-error
    <Flex align="center" justify="space-between" mb="10px">
      {/* @ts-expect-error */}
      <Flex justify="flex-end" width="44px" mr="12px" pb="10px">
        {/* @ts-expect-error */}
        <NotationTag isUma={isUma}>{code}</NotationTag>
      </Flex>
      <Description>{desc}</Description>
    </Flex>
  );
}

export default NotationListItem;
